<template>
	<c-dialog ref="dialog" mode="slide" width="500" mask-close @close="dialogFormEditConfirm($refs.form, arguments)" @resolve="editHandle">
		<c-form ref="form" unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
            <c-form-item label="委外单" required>
                <c-select name="out_sourcing_order_id" async v-model="out_sourcing_order_id" @search="searchSourcingOrder" :value-data="sourcingOrderOptions" @change="changeSourcingOrder($event)" :disabled="settle_id>0" :clear="false">
                    <template #option="{data, selected}">
                        <select-option
                            :name="data.name"
                            :info="[
                                `工单编号：${data.data.work_code || '-'}`,
                                `工序名称：${data.data.process_name || '-'}`,
						        `产品信息：${data.data.product_code} | ${data.data.product_name} | ${data.data.product_spec}`
							]"
                            :selected="selected"
                        ></select-option>
                    </template>
                </c-select>
            </c-form-item>
            <c-form-item label="已结算/可结算">
                <c-input name="can_settle_money" disabled></c-input>
            </c-form-item>
			<c-form-item label="结算金额" required>
				<c-input type="stepper" name="settle_money" decimal="6" :range="[0,99999999]" step="1"></c-input>
			</c-form-item>
			<c-form-item label="备注">
				<c-input type="textarea" name="remark" maxlength="500"></c-input>
			</c-form-item>
            <!--自定义字段控件-->
            <custom-form ref="customForm" work-type="36"></custom-form>
		</c-form>
	</c-dialog>
</template>

<script>
export default {
	name: 'out_sourcing_order_settle_edit',

	data() {
		return {
			settle_id:0,
            out_sourcing_order_id:0,
            sourcingOrderOptions:[]
		}
	},

	methods: {
		/**
		 * 打开发货 、收货框
		 * @param data      结算单号
		 */
		open(data) {
            this.settle_id = 0;
            this.$refs.form.clear();
            this.$refs.customForm.init();//自定义字段初始化
            if (data && data.id){
                this.settle_id = data.id;
                this.getSettleDetail();
            }else if (data && data.out_sourcing_order_id){
                this.out_sourcing_order_id = data.out_sourcing_order_id;
                //选中委外单信息
                this.sourcingOrderOptions = [{
                    name: data.outsourcing_code + ' | ' +data.work_code,
                    value: this.out_sourcing_order_id
                }]
                this.$refs.form.set(data);
            }
            //填充form表单
			this.$refs.dialog.open({
				title: this.settle_id>0?'编辑委外结算单':'创建委外结算单'
			});
		},

        /*******搜索【委外单】下拉框信息*****************/
        searchSourcingOrder(keyword, resolve){
            this.request({
                url:'/out/sourcing/order/options',
                data: {
                    keyword:keyword
                },
                success:data => {
                    var option = data.map(item => {
                        return {
                            name: item.order_code + ' | ' +item.work_code,
                            value: item.id,
                            data: item
                        }
                    });
                    resolve(option);
                }
            })
        },

        /********变更工单下拉框数据*************/
        changeSourcingOrder(selectData){
            //可结算金额 = 单价*已回数
            var money1 = (parseFloat(selectData.data.receive_count) * parseFloat(selectData.data.price)).toFixed(2);
            var money2 = parseFloat(selectData.data.settled_money).toFixed(2);
            var formData = this.$refs.form.get();
            formData.can_settle_money = money2 +' / '+money1;
            this.$refs.form.set(formData);
        },
        /***********查询结单详情*************/
        getSettleDetail(){
            this.request({
                url:'/out/sourcing/settle/detail',
                data: {id:this.settle_id},
                loading: true,
                success: data => {
                    this.out_sourcing_order_id = data.settle_info.out_sourcing_order_id;
                    var formData = data.settle_info;
                    var money1 = (parseFloat(data.order_info.receive_count) * parseFloat(data.order_info.price)).toFixed(2);
                    var money2 = parseFloat(data.order_info.settled_money).toFixed(2);
                    formData.can_settle_money = money2 +' / '+money1;
                    this.$refs.form.set(formData);
                    //选中委外单信息
                    this.sourcingOrderOptions = [{
                        name: formData.outsourcing_code + ' | ' +formData.work_code,
                        value: formData.out_sourcing_order_id
                    }];
                }
            });
        },

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this.settle_id>0?'/out/sourcing/settle/edit':'/out/sourcing/settle/add',
				rule: {
                    out_sourcing_order_id: '请选择委外单',
                    settle_money: '请输入结算金额',
                    ...this.$refs.customForm.rule
                },
				dataFormatter: data => {
					data.out_sourcing_order_id = this.out_sourcing_order_id;
                    data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
                    return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message:'提交成功',  // 提示内容,
						type: 'success'
					});
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>